import React from 'react';
import { AlertTriangleIcon, CheckCircle2Icon, RefreshCwIcon } from 'lucide-react';
import { Countdown } from './Countdown';
import { CtaButton } from './CtaButton';
const included = ['6 Tomos completos', '6 Bonos estratégicos ($120 USD)', '40 semanas resueltas', 'Acceso inmediato en 5 minutos'];
export function Offer({
  id
}: {
  id?: string;
}) {
  return <section id={id} className="bg-white px-4 py-16" data-id="element-141" data-mp="tyv4n93ba9wo">
      <div className="mx-auto max-w-md" data-id="element-142" data-mp="tzmqhs73wt9r">
        <div className="rounded-2xl border-2 border-magenta/20 bg-magenta/5 p-5 text-center" data-id="element-143" data-mp="ozryflblhxn4">
          <p className="text-xs font-bold uppercase tracking-widest text-magenta" data-id="element-144" data-mp="p24qwsezbqef">
            ⏰ Precio de lanzamiento — cierra en:
          </p>
          <div className="mt-3" data-id="element-145" data-mp="ywwmxrswy573">
            <Countdown data-id="element-146" data-mp="ywmyw9rfi841" />
          </div>
          <p className="mt-4 inline-flex items-center gap-1.5 text-xs font-semibold text-navy/70" data-id="element-147" data-mp="2fbxzvcsc4rep">
            <AlertTriangleIcon className="h-4 w-4 text-magenta" data-id="element-148" data-mp="2admmis2tzyrq" />
            Después sube $30 USD. No vuelve.
          </p>
        </div>

        <div className="mt-4 rounded-xl bg-navy/5 px-4 py-3" data-id="element-149" data-mp="pjflwfbn0vla">
          <div className="mb-1.5 flex items-center justify-between text-xs font-bold text-navy" data-id="element-150" data-mp="uisg5l4u94xw">
            <span className="text-magenta" data-id="element-151" data-mp="zhvc8g2uc0tq">🔴 68% de cupos tomados</span>
            <span className="text-navy/50" data-id="element-152" data-mp="zgkaelsyh359">Precio lanzamiento</span>
          </div>
          <div className="h-2.5 w-full overflow-hidden rounded-full bg-navy/10" data-id="element-153" data-mp="13hw16unkfuf1">
            <div className="h-full w-[68%] rounded-full bg-magenta" data-id="element-154" data-mp="6vakheigdmpn" />
          </div>
        </div>

        <div className="mt-6 overflow-hidden rounded-3xl border border-navy/10 bg-white shadow-soft" data-id="element-155" data-mp="btc1zv08ddz0">
          <div className="bg-navy px-6 py-5 text-center text-white" data-id="element-156" data-mp="fsuqf0r9g76l">
            <h3 className="font-display text-xl font-black" data-id="element-157" data-mp="kle3zxpy72be">
              📘 Método Domingo Libre
            </h3>
            <p className="mt-1 text-sm text-white/70" data-id="element-158" data-mp="3k7uhuiwexxt6">
              6 Tomos + 6 Bonos · 40 semanas resueltas
            </p>
          </div>
          <div className="px-6 py-6" data-id="element-159" data-mp="3o7uv407s02yn">
            <ul className="space-y-2.5" data-id="element-160" data-mp="veyzwmtrt6zt">
              {included.map(item => <li key={item} className="flex items-start gap-2.5 text-sm" data-id="element-161" data-mp="qh5uvx47ej14">
                  <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-teal" data-id="element-162" data-mp="155k7v0vc3nve" />
                  <span className="font-medium text-navy/80" data-id="element-163" data-mp="157mtl8pgeuub">{item}</span>
                </li>)}
            </ul>

            <div className="mt-6 text-center" data-id="element-164" data-mp="cgmoeufdzl12">
              <span className="font-display text-xl font-bold text-navy/40 line-through" data-id="element-165" data-mp="chelk9omtqtg">
                $97 USD
              </span>
              <div className="mt-1 font-display text-5xl font-black text-magenta" data-id="element-166" data-mp="7k4l7yzpfuqu">
                $12.99 <span className="text-2xl" data-id="element-167" data-mp="lf850k1aspz7">USD</span>
              </div>
              <p className="mt-1 text-xs font-semibold uppercase tracking-wide text-navy/50" data-id="element-168" data-mp="heei9tzldh7w">
                Un solo pago · Acceso de por vida
              </p>
              <p className="mx-auto mt-3 inline-flex items-center justify-center gap-1.5 rounded-full bg-teal/10 px-3 py-1.5 text-xs font-bold text-teal" data-id="element-169" data-mp="1svo06c32o173">
                <RefreshCwIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-170" data-mp="20gqixsdksy7u" />
                Cambio de moneda automático según tu país.
              </p>
            </div>

            <div className="mt-6" data-id="element-171" data-mp="1qhrgirjelyta">
              <CtaButton data-id="element-172" data-mp="1qiu7ezgq8197" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}